import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { useCurrentSite } from '@hotjar/site';
import { useCurrentUser } from '@hotjar/user';
import { getSurveyTemplateIdFromAppState } from '@hotjar/webapp/features/Surveys/Templates';

const CACHE_TIME = 60 * 1000; // 1 min

export const SURVEY_TEMPLATE = 'surveyTemplate';

export const useSurveyTemplate = (): UseQueryResult<string | null, Error> => {
  const { data: currentUser } = useCurrentUser();
  const { data: currentSite } = useCurrentSite();
  const userId = currentUser?.id;
  const siteId = currentSite?.id;

  return useQuery(
    [SURVEY_TEMPLATE, { siteId }],
    () => getSurveyTemplateIdFromAppState(userId as number, siteId as number),
    {
      enabled: !!userId && !!siteId,
      retry: false,
      staleTime: CACHE_TIME,
      cacheTime: CACHE_TIME,
      select: (data) => data?.templateId,
    },
  );
};
